import { render, staticRenderFns } from "./EmergencyLogin.vue?vue&type=template&id=500c0fa3"
import script from "./EmergencyLogin.vue?vue&type=script&lang=js"
export * from "./EmergencyLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports